var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillDive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 21,
    viewBox: "0 0 108 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3684_23079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5862 1.11816V17.9271C73.5862 18.7208 73.621 19.5068 73.6895 20.2827H69.9091C69.8394 19.8592 69.8058 19.4356 69.8058 19.012C69.4947 19.4712 69.0331 19.8452 68.4208 20.1365C67.8074 20.4277 67.1217 20.5727 66.3614 20.5727C64.5309 20.5727 63.0116 19.924 61.8033 18.6266C60.595 17.3293 59.9902 15.6757 59.9902 13.6635C59.9902 11.6512 60.5776 10.0498 61.751 8.75372C62.9245 7.45632 64.4177 6.80762 66.2307 6.80762C68.0438 6.80762 69.1475 7.2579 69.7013 8.15717V1.11816H73.5862ZM64.7947 11.2824C64.2335 11.8471 63.9535 12.6497 63.9535 13.6915C63.9535 14.7332 64.2335 15.5409 64.7947 16.1133C65.356 16.6869 66.0416 16.9731 66.8529 16.9731C67.6643 16.9731 68.3511 16.6869 68.9124 16.1133C69.4736 15.5396 69.7536 14.7332 69.7536 13.6915C69.7536 12.6497 69.4723 11.8471 68.9124 11.2824C68.3511 10.7176 67.6643 10.4352 66.8529 10.4352C66.0416 10.4352 65.3547 10.7176 64.7947 11.2824Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5638 4.771C76.1146 4.31182 75.8906 3.75598 75.8906 3.10347C75.8906 2.45095 76.1146 1.89511 76.5638 1.43593C77.013 0.976755 77.5481 0.747803 78.1691 0.747803C78.79 0.747803 79.3562 0.976755 79.8129 1.43593C80.2696 1.89511 80.4998 2.45095 80.4998 3.10347C80.4998 3.75598 80.2708 4.3131 79.8129 4.771C79.3549 5.23018 78.8074 5.45913 78.1691 5.45913C77.5307 5.45913 77.0118 5.23018 76.5638 4.771ZM80.1638 20.2825H76.2279V7.12666H80.1638V20.2825Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3631 7.12671L90.469 20.2826H86.507L81.2246 7.12671H85.4978L88.4755 15.3054L91.2206 7.12671H95.3644H95.3631Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.479 15.5434L107.768 16.4961C107.439 17.7133 106.757 18.7156 105.722 19.5004C104.687 20.2852 103.391 20.6783 101.837 20.6783C99.973 20.6783 98.3889 20.0435 97.0848 18.7729C95.7807 17.5022 95.1299 15.799 95.1299 13.6647C95.1299 11.5303 95.7645 9.95057 97.0338 8.66208C98.303 7.37359 99.8087 6.72998 101.552 6.72998C103.554 6.72998 105.13 7.32526 106.278 8.51708C107.425 9.70763 108 11.3624 108 13.4803C108 14.1506 107.974 14.5652 107.923 14.7242H98.9638C98.9986 15.448 99.301 16.0521 99.8697 16.538C100.44 17.0239 101.113 17.2656 101.889 17.2656C103.218 17.2656 104.082 16.6919 104.479 15.5446V15.5434ZM99.0409 12.1282H104.194C104.159 11.5278 103.93 11.0076 103.507 10.5662C103.084 10.1248 102.449 9.90478 101.603 9.90478C100.843 9.90478 100.239 10.1337 99.79 10.5929C99.3408 11.0521 99.0907 11.5634 99.0384 12.1282H99.0409Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2464 17.0225L25.4638 16.2288C25.5509 16.9169 25.8458 17.4906 26.3511 17.9497C26.855 18.3911 27.5332 18.6112 28.3856 18.6112C29.0464 18.6112 29.5678 18.4522 29.951 18.1342C30.333 17.7984 30.5247 17.3926 30.5247 16.9169C30.5247 16.0698 29.9859 15.5229 28.907 15.2761L26.7679 14.7991C25.7936 14.588 25.0295 14.1631 24.4721 13.5284C23.9158 12.8924 23.6371 12.1255 23.6371 11.2249C23.6371 10.131 24.0714 9.18596 24.9412 8.39226C25.8284 7.59856 26.8799 7.20044 28.0969 7.20044C28.897 7.20044 29.6101 7.32382 30.236 7.57058C30.8619 7.79953 31.3484 8.10862 31.6969 8.49656C32.044 8.88451 32.3054 9.24702 32.4796 9.58154C32.6538 9.91734 32.7844 10.2608 32.8703 10.6144L30.7051 11.4348C30.6703 11.2236 30.6093 11.0201 30.5222 10.8255C30.4351 10.6131 30.2957 10.3841 30.1053 10.1374C29.9311 9.89063 29.671 9.69602 29.3226 9.55483C28.9754 9.39584 28.566 9.31697 28.0969 9.31697C27.4884 9.31697 26.9844 9.48487 26.5838 9.8194C26.2017 10.1552 26.0101 10.552 26.0101 11.0112C26.0101 11.8227 26.4879 12.3353 27.4449 12.5465L29.4794 12.9967C30.5919 13.2435 31.4443 13.7027 32.0353 14.373C32.6438 15.0255 32.9487 15.8294 32.9487 16.7821C32.9487 17.7882 32.5406 18.6977 31.723 19.5092C30.9229 20.3207 29.8017 20.7264 28.3582 20.7264C26.8102 20.7264 25.602 20.3385 24.7321 19.5613C23.8623 18.7676 23.3671 17.9205 23.2451 17.0199L23.2464 17.0225Z",
    fill: "url(#paint0_linear_3684_23079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3683 7.59859L40.0213 12.9726L45.4728 20.3322H42.3955L38.3003 14.719L36.5532 16.4934V20.3322H34.1279V1.16504H36.5532V13.2372L41.9787 7.59859H45.3696H45.3683Z",
    fill: "url(#paint1_linear_3684_23079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1691 20.3323H45.7438V7.5987H48.1691V20.3323ZM45.6915 4.05122C45.3605 3.69761 45.1963 3.27405 45.1963 2.78053C45.1963 2.28701 45.3618 1.86218 45.6915 1.50985C46.0387 1.15624 46.4568 0.980713 46.9434 0.980713C47.4299 0.980713 47.848 1.15751 48.1952 1.50985C48.5424 1.84564 48.7166 2.2692 48.7166 2.78053C48.7166 3.29186 48.5424 3.69888 48.1952 4.05122C47.848 4.38701 47.4299 4.55364 46.9434 4.55364C46.4568 4.55364 46.0387 4.38574 45.6915 4.05122Z",
    fill: "url(#paint2_linear_3684_23079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7063 20.3322H50.2549V1.16504H52.7063V20.3322Z",
    fill: "url(#paint3_linear_3684_23079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2424 20.3322H54.791V1.16504H57.2424V20.3322Z",
    fill: "url(#paint4_linear_3684_23079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3989 6.23386L18.1093 7.69025L17.0877 8.34276L14.798 9.8017L13.7764 10.4529L10.2001 12.731L6.63 10.4555H6.62875L5.60961 9.80551L3.31375 8.34403L2.29337 7.69534L0 6.23386L10.2088 0L20.3989 6.23386Z",
    fill: "url(#paint5_linear_3684_23079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3989 14.5028L10.2001 20.9999L0 14.5028L2.28342 13.1074L10.2001 18.152L18.1193 13.1074L20.3989 14.5028Z",
    fill: "url(#paint6_linear_3684_23079)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3989 10.3537L18.1093 11.7974L17.0877 12.441L10.2001 16.7834L3.31375 12.4423L2.29337 11.7999L0 10.3537L2.28217 8.9749H2.28342L4.57679 10.4224L5.59717 11.0647L10.2001 13.9673L14.8092 11.0622L15.8296 10.4173L18.1193 8.97363L20.3989 10.3537Z",
    fill: "url(#paint7_linear_3684_23079)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3684_23079",
    x1: 24.4609,
    y1: 13.9672,
    x2: 56.2744,
    y2: 13.9563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3684_23079",
    x1: 24.4592,
    y1: 10.7543,
    x2: 56.2727,
    y2: 10.7446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3684_23079",
    x1: 24.4589,
    y1: 10.6641,
    x2: 56.2724,
    y2: 10.6544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3684_23079",
    x1: 24.4591,
    y1: 10.7581,
    x2: 56.2727,
    y2: 10.7484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3684_23079",
    x1: 24.4595,
    y1: 10.7594,
    x2: 56.2731,
    y2: 10.7497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#863AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5936E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3684_23079",
    x1: 0,
    y1: 6.36487,
    x2: 20.3989,
    y2: 6.36487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A23AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#813AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6037E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3684_23079",
    x1: 0,
    y1: 17.0543,
    x2: 20.3989,
    y2: 17.0543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008F8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51E0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3684_23079",
    x1: 0,
    y1: 12.8785,
    x2: 20.3989,
    y2: 12.8785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4365AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558BDC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3684_23079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 21,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillDive);
export default __webpack_public_path__ + "static/media/skill_dive.0f4909417dba0be9782ac3b02b72c29a.svg";
export { ForwardRef as ReactComponent };